import type { DotsSettings } from "../shared/dots-settings";
import type { TankSettings } from "../shared/tank-settings";
export interface User {
  id: number;
  username: string;
  isAdmin: boolean;
  subscription: boolean;
  disabled: boolean;
}

export interface PublicRoom {
  roomId: string;
  gameId: string;
  title: string;
  clients: number;
  maxClients: number;
  phase: string;
  mode?: "arena" | "wild" | "outbreak";
  difficulty?: "easy" | "normal" | "hard";
  dots?: DotsSettings;
  tanks?: TankSettings;
  theme?:string;
}

export interface CatalogGame {
  playMode?: "solo";
  id: string;
  slug: string;
  name: string;
  description: string;
  cover: string;
  status: "available" | "coming_soon";
  minPlayers: number;
  maxPlayers: number;
  path: string;
  rooms: number;
  players: number;
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(path, {
    ...options,
    credentials: "same-origin",
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...options.headers,
    },
  });
  if (response.status === 204) return undefined as T;
  const body = (await response.json()) as T & { error?: string };
  if (!response.ok) throw new Error(body.error ?? `HTTP ${response.status}`);
  return body;
}
